export default "__VITE_ASSET__CPK80m6R__"